export default (state, {
  data,
  instanceKey
}) => {
  let newFieldValue = {
    ...state
  };

  const keys = Object.keys(data);

  keys.forEach(field => {
    newFieldValue[`${instanceKey}_previous_${field}`] = data[field];
  });

  return newFieldValue;
};
